import SpriteSymbol from "../../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "percona",
  "use": "percona-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"percona\"><path d=\"M9 2C5.13 2 2 5.13 2 9c0 2.38 1.19 4.48 3 5.74V9c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4c-.95 0-1.81-.35-2.5-.9v3.44c.78.3 1.62.47 2.5.47 3.87 0 7-3.13 7-7S12.87 2 9 2zm2.5 7a2.5 2.5 0 00-5 0 2.5 2.5 0 005 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol